// extracted by mini-css-extract-plugin
module.exports = {"phe":"HealthExaminationPage_phe__3sIG7","main":"HealthExaminationPage_main__1XW7o"};